module.exports = __webpack_public_path__ + "img/1452987826.2e8e5edf.jpg";